// extracted by mini-css-extract-plugin
export default {"large":"Pfirst_large__HYJo8","normal":"Pfirst_normal__VxHRX","Pfirst":"Pfirst_Pfirst__6xsdm","Pfirst_en":"Pfirst_Pfirst_en__ETzb7","text":"Pfirst_text__ptB8V"};